import { AirtablePermissions } from "@/types/crm/airtable/common";

/**
 * @constant The required permissions for Airtable CRM integration.
 */
export const airtableRequiredPermissions: AirtablePermissions[] = ["create"] as const;
